import * as yup from "yup";

import {
  endDateValidationRule,
  inProgressDateRule,
  inProgressSimpleArrayRule,
  inProgressStringRule,
  inProgressWithBoolParentStringRule,
  nullableNumberRule,
  regionsRule,
  requiredStringRule,
  startDateValidationRule,
} from "../../../../utils/validationUtils";
import { CAMPAIGN_TEMPLATE } from "../../../../types/templates/campaign-brief/campaign-brief-template.enum";

/**
 * Fields shared between Brand and General
 * Brand and General will extend this object with their own fields and can overwrite the ones
 *  defined if they need to.
 */
const commonFields = yup.object({
  startAt: startDateValidationRule,
  endAt: endDateValidationRule,

  executionPlansDueAt: inProgressDateRule("You must define the execution plans due date."),
  languages: inProgressSimpleArrayRule(yup.number(), "You must select at least one Language."),

  otherMarketingChannels: yup.string(),
  regions: regionsRule,
  status: yup.string(),

  vendorAssetsLocation: inProgressWithBoolParentStringRule(
    "areVendorAssetsProvided",
    "You must provide location of vender assets provided."
  ),
});

/**
 * BRAND
 */
export const BrandSchema = commonFields.shape({
  additionalDetails: yup.string(),
  brandFrameworkSupport: yup.string(),

  campaignContent: inProgressStringRule("You must provide Campaign Content."),

  customerMessage: yup.string(),
  customerTakeaway: yup.string(),
  insight: yup.string(),

  marketingChannels: inProgressSimpleArrayRule(
    yup.number(),
    "You must select at least one Marketing Channel."
  ),

  opportunity: yup.string(),
  tonality: yup.string(),
});

/**
 * GENERAL
 */
export const GeneralSchema = commonFields.shape({
  audience: yup.string(),

  campaignOverview: inProgressStringRule("You must provide Campaign Overview."),
  marketingChannels: inProgressSimpleArrayRule(
    yup.number(),
    "You must select at least one Marketing Channel."
  ),

  messagingPrimary: yup.string(),
  messagingSecondary: yup.string(),
  objectives: yup.string(),
  offerDetails: yup.string(),
  previousResults: yup.string(),
});

/**
 * SIMPLE
 */
export const SimpleSchema = commonFields.shape({
  additionalDetails: yup.string(),
  campaignOverview: inProgressStringRule("You must provide Campain Overview."),
});

/**
 * NEW PRODUCT
 */
export const NewProductSchema = commonFields.shape({
  additionalDetails: yup.string(),

  background: requiredStringRule("You must provide Background."),

  keyFeatures: yup.string(),

  launchDate: inProgressDateRule("You must define the launch date."),
  marketingChannels: inProgressSimpleArrayRule(
    yup.number(),
    "You must select at least one Marketing Channel."
  ),
  marketingSupportLevel: inProgressStringRule("You must select Marketing Support Level"),

  targetSalesForecast: nullableNumberRule,
  targetTimeframe: nullableNumberRule,
  targetUnitForecast: nullableNumberRule,
});

export function getValidationSchema(template: CAMPAIGN_TEMPLATE) {
  switch (template) {
    case CAMPAIGN_TEMPLATE.SIMPLE:
      return SimpleSchema;
    case CAMPAIGN_TEMPLATE.NEW_PRODUCT:
      return NewProductSchema;
    case CAMPAIGN_TEMPLATE.BRAND:
      return BrandSchema;
    case CAMPAIGN_TEMPLATE.GENERAL:
    default:
      return GeneralSchema;
  }
}
